import Stack from '@mui/material/Stack';
import React, { Fragment } from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import { Styles } from '@t2c/shared-fe';
import InfiniteScroll from 'react-infinite-scroll-component';
import EmptyPage from '../../../../Common/EmptyPage';
import { BrollCaptionsAndRenderType, CardTypeEnum, ContentType, EMPTY_PAGE_TEXT, extractDate, extractTime } from '../../../../utils';
import { AvatarCard } from '../../../../components/avatar-library/PrivateAvatarCard';
import { InfiniteData } from '@tanstack/react-query';
import { BrollCaptionVideo } from 'apps/t2c-fe/@types';

interface BrollCaptionResponse {
  brollCaptionVideos: BrollCaptionVideo[];
  videosTotalCount: number;
  recentVideosCount: number;
}

interface Props {
  allData: InfiniteData<BrollCaptionResponse>,
  isLoading: boolean,
  refetch: Function,
  fetchNextPage: any,
  hasNextPage: boolean,
  setSelectedIndex: any,
  selectedIndex: number | null,
}

export const CaptionsTab: React.FC<Props> = ({
  allData,
  isLoading,
  refetch: refetchData,
  fetchNextPage,
  hasNextPage,
  setSelectedIndex,
  selectedIndex,
}) => {
  return (
    <>
    {isLoading ? (
      <Stack sx={styles.loader}>
        <CircularProgress />
      </Stack> 
    ) : !(allData?.pages?.[0]?.brollCaptionVideos ?? []).length ? (
      <Box sx={styles.container}>
        <EmptyPage text={EMPTY_PAGE_TEXT.video} type={ContentType.Video} />
      </Box>
    ) : (
      <InfiniteScroll
        dataLength={
          allData?.pages?.reduce((acc, page) => acc + page.brollCaptionVideos.length, 0) || 0
        }
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={
          <Box p={2} textAlign={'center'}>
            <h2>loading...</h2>
          </Box>
        }
        scrollableTarget='scrollableDiv'
        style={{ overflow: 'visible' }}
      >
        <Grid container justifyContent={''} spacing={4}>
          {allData?.pages &&
            allData?.pages?.map((page, pageIndex) => (
              <Fragment key={pageIndex}>
                {(page?.brollCaptionVideos ?? []).map((data,index) => {
                  return (
                    <Grid item flex={1} xs={12} sm={4} key={data.id}>
                      <AvatarCard
                        avatarLogo={data?.thumbnail}
                        avatarName={data.name}
                        status={data.status}
                        message="We hit a glitch in the matrix! Your video didn’t make it. Give it another shot! "
                        handleClick={() =>
                          {
                            if(data.status === 'Success') {
                              setSelectedIndex(index)
                            }
                          }
                        }
                        type={CardTypeEnum.Captions}
                        date={extractDate(
                          data.updatedAt ? data.updatedAt : data.createdAt
                        )}
                        time={extractTime(
                          data.updatedAt ? data.updatedAt : data.createdAt
                        )}
                        creationId={data.id}
                        url={data?.renderedUrl}
                        refetchData={refetchData}
                        isActive={selectedIndex === index}
                      />
                    </Grid>
                  );
                })}
              </Fragment>
            ))}
        </Grid>
      </InfiniteScroll>
    )}
    </>
  );
};

const styles: Styles = {
  container: {
    overflow: 'auto',
    height: '300px'
  },
  noDataText: {
    width: '100%',
    textAlign: 'center',
    marginTop: 2,
    color: (theme) => theme.palette.text.secondary,
  },
  skeleton: {
    borderRadius: 2,
  },
  noDataFoundContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 300,
    width: '100%',
  },
};
